import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { testimonials } from '../data/site';
function Stars() {
  return <div className="flex items-center gap-1" role="img" aria-label="Calificación: 5 de 5 estrellas" data-id="element-290" data-mp="3krp1qv22efll">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-fucsia text-fucsia" aria-hidden="true" data-id="element-291" data-mp="3b0ufhqotjg05" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section id="opiniones" className="w-full bg-blush-50 py-20 sm:py-28" data-id="element-292" data-mp="370aj4pc2kgf2">
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-8" data-id="element-293" data-mp="31yuvcpiibvsz">
        <div className="max-w-2xl" data-id="element-294" data-mp="2x0jnulfopxdx">
          <p className="text-sm font-semibold text-rosegold-dark" data-id="element-295" data-mp="2x1utkqsoxf7o">Opiniones</p>
          <h2 className="mt-3 font-serif text-4xl font-semibold leading-tight text-ink sm:text-5xl" data-id="element-296" data-mp="2s28h4jkos2zx">
            Lo que dicen las clientas
          </h2>
        </div>

        <ul className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-297" data-mp="v72fffjqcsi4">
          {testimonials.map(testimonial => <li key={testimonial.id} className="flex h-full flex-col rounded-3xl border border-blush-200 bg-blush-100 p-7" data-id="element-298" data-mp="h5y7wcgvp92k">
              <QuoteIcon className="h-6 w-6 text-fucsia-deep/60" aria-hidden="true" data-id="element-299" data-mp="m6cgpwqb0n1n" />
              <blockquote className="mt-4 text-[0.98rem] leading-relaxed text-ink" data-id="element-300" data-mp="79bnfosgsk12">
                {testimonial.quote}
              </blockquote>
              <div className="mt-auto pt-7" data-id="element-301" data-mp="zwg08fxsu2ne">
                <div className="flex items-center gap-3 border-t border-blush-300/70 pt-5" data-id="element-302" data-mp="zxqyk08h6i74">
                  <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-fucsia-deep font-serif text-base font-semibold text-white" data-id="element-303" data-mp="14uhi4xjhnvxa">
                    {testimonial.initials}
                  </span>
                  <div className="min-w-0" data-id="element-304" data-mp="v3mvhs2byubb">
                    <p className="truncate font-semibold text-ink" data-id="element-305" data-mp="1iv1xfjq739m1">{testimonial.name}</p>
                    <p className="text-xs text-ink-soft" data-id="element-306" data-mp="1nmk1whrffsbr">{testimonial.service}</p>
                  </div>
                  <div className="ml-auto" data-id="element-307" data-mp="1xi91r6l6d9by">
                    <Stars data-id="element-308" data-mp="1xh7nkt8v46q0" />
                  </div>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}